'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MediaBody = require('react-bootstrap/lib/MediaBody');

var _MediaBody2 = _interopRequireDefault(_MediaBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MediaBody2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/MediaBody.js
// module id = 633
// module chunks = 0